import { Button, ButtonProps } from "@bigcommerce/big-design";
import { forwardRef } from "react";

export const WButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <Button ref={ref} {...rest}>
      {children}
    </Button>
  );
});

WButton.displayName = 'WButton';